<div class="info-warning vo-info-box--warning" [innerHtml]="unauthorizedMessage | localizeLabel  | toTrustedHtml"></div>
